import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WindowRef } from 'app/_services/native-window.service';
import { PermitsService } from 'app/forests/services/permits.service';
import { ModalService } from 'app/shared/modal/modal.service';

@Component({
    selector: 'app-paygov-error',
    templateUrl: './paygov-error.component.html',
    styleUrls: ['../error-pages.scss'],
    standalone: false
})
export class PayGovErrorComponent implements OnInit  {
  permit: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router, 
    private modalService: ModalService,
    private permitsService: PermitsService,
    private winRef: WindowRef,
  ) {}

  ngOnInit() {
    this.route.data.subscribe((res) => {
      this.permit = res.permit;
      if (res.permit.status === 'Completed') { this.router.navigate(["../"], {relativeTo: this.route}) }
    })
    this.modalService.confirmEvent.subscribe(res => {
      if (res) { this.cancelPurchase() }
    })
  }

  redirectToPaygov() {
    this.permitsService.paygovRedirect(this.permit.permitId).subscribe((res: any) => {
      this.winRef.getNativeWindow().location.href = `${res.payGovUrl}?token=${res.token}&tcsAppID=${res.tcsAppID}`;
    })
  }

  confirmationModal() {
    const modalConfig = {
      title: 'Warning!',
      titleIcon: '<i class="fas fa-exclamation-triangle"></i>',
      body: 'Are you sure you want to cancel the purchase of this permit?',
      confirmButtonText: 'Confirm',
    };
    this.modalService.open(modalConfig);
  }
  
  cancelPurchase() {
    this.modalService.modalOpen.next(false);
    this.modalService.confirmEvent.next(false);
    this.router.navigate(['/']);
  }
}
